import React from 'react';
import { InstagramIcon, FacebookIcon, TwitterIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-matte-black border-t border-off-white/10 py-12 px-6" data-id="element-87">
      <div className="max-w-7xl mx-auto" data-id="element-88">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-89">
          {/* Brand */}
          <div data-id="element-90">
            <div className="font-playfair text-2xl font-bold text-soft-gold mb-4 tracking-wider" data-id="element-91">
              KINGSMAN STUDIO
            </div>
            <p className="font-inter text-off-white/60 text-sm leading-relaxed" data-id="element-92">
              Crafting precision haircuts for the modern gentleman since 2020.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-93">
            <h3 className="font-inter font-semibold text-off-white mb-4" data-id="element-94">
              Quick Links
            </h3>
            <div className="space-y-2 font-inter text-sm" data-id="element-95">
              <a href="#services" className="block text-off-white/60 hover:text-soft-gold transition-colors" data-id="element-96">
                Services
              </a>
              <a href="#barbers" className="block text-off-white/60 hover:text-soft-gold transition-colors" data-id="element-97">
                Barbers
              </a>
              <a href="#reviews" className="block text-off-white/60 hover:text-soft-gold transition-colors" data-id="element-98">
                Reviews
              </a>
              <a href="#location" className="block text-off-white/60 hover:text-soft-gold transition-colors" data-id="element-99">
                Location
              </a>
            </div>
          </div>

          {/* Social */}
          <div data-id="element-100">
            <h3 className="font-inter font-semibold text-off-white mb-4" data-id="element-101">
              Follow Us
            </h3>
            <div className="flex gap-4" data-id="element-102">
              <a href="#" className="w-10 h-10 rounded-full bg-off-white/5 border border-off-white/10 flex items-center justify-center text-off-white/60 hover:text-soft-gold hover:border-soft-gold transition-all" data-id="element-103">
                <InstagramIcon size={20} data-id="element-104" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-off-white/5 border border-off-white/10 flex items-center justify-center text-off-white/60 hover:text-soft-gold hover:border-soft-gold transition-all" data-id="element-105">
                <FacebookIcon size={20} data-id="element-106" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-off-white/5 border border-off-white/10 flex items-center justify-center text-off-white/60 hover:text-soft-gold hover:border-soft-gold transition-all" data-id="element-107">
                <TwitterIcon size={20} data-id="element-108" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-off-white/10 pt-8 text-center" data-id="element-109">
          <p className="font-inter text-sm text-off-white/40" data-id="element-110">
            © 2024 Kingsman Studio. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}